import React, {createContext, useContext, useEffect, useState} from "react";

export const YuJaGlobalState = createContext({
    loading: false,
    setLoading: () => {},
    isTokenExpiredModalShowUp: false,
    setIsTokenExpiredModalShowUp: () => {},
    isCookieEnabled: true,
    isOnline: true,
    effectiveType: null,
    missedResponseMap: {},
    setMissedResponseMap: () => {},
    missedReactionMap: {},
    setMissedReactionMap: () => {},
});

export function YuJaGlobalStateProvider({ children }) {
    const [loading, setLoading] = useState(false);
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const [effectiveType, setEffectiveType] = useState(null);
    const [missedResponseMap, setMissedResponseMap] = useState({});
    const [missedReactionMap, setMissedReactionMap] = useState({});
    const [isCookieEnabled, setIsCookieEnabled] = useState(window.navigator.cookieEnabled);
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    // let {width, height} = useWindowDimensions();
    // const [mainContainerDimension, setMainContainerDimension] = useState({width, height});
    // const [mainExisted, setMainExisted] = useState(false);

    const [isTokenExpiredModalShowUp, setIsTokenExpiredModalShowUp] = useState(false);
    const data = {
        loading,
        setLoading,
        isTokenExpiredModalShowUp,
        setIsTokenExpiredModalShowUp,
        isCookieEnabled,
        isOnline,
        effectiveType,
        missedResponseMap,
        setMissedResponseMap,
        missedReactionMap,
        setMissedReactionMap,
        sidebarCollapsed,
        setSidebarCollapsed
        // mainContainerDimension
    }

    const updateNetworkStatus = () => {
        setIsOnline(!!window.navigator.onLine);
    }

    useEffect(() => {
        window.addEventListener("load", updateNetworkStatus);
        window.addEventListener("online", updateNetworkStatus);
        window.addEventListener("offline", updateNetworkStatus);

        return () => {
            window.removeEventListener("load", updateNetworkStatus);
            window.removeEventListener("online", updateNetworkStatus);
            window.removeEventListener("offline", updateNetworkStatus);
        };
    }, []);


    useEffect(() => {
        const {connection, mozConnection, webkitConnection} = window.navigator;

        const conn = connection || mozConnection || webkitConnection;

        if (conn) {
            // Initial setup of effectiveType
            setEffectiveType(conn.effectiveType);

            // Add an event listener to update effectiveType when it changes
            const handleConnectionChange = () => {
                setEffectiveType(conn.effectiveType);
            };

            conn.addEventListener('change', handleConnectionChange);

            // Clean up the event listener when the component unmounts
            return () => {
                conn.removeEventListener('change', handleConnectionChange);
            };
        }
    }, []);


    return (
        <YuJaGlobalState.Provider value={data} >
            {children}
        </YuJaGlobalState.Provider>
    );
}

export function useLoading() {
    const context = useContext(YuJaGlobalState);
    if (!context) {
        throw new Error("useLoading must be used within LoadingProvider");
    }
    return context;
}